import React from 'react';
import { MimaButton, MimaInput, MimaText } from '../../../components';
import useAdminLoginLogic from './useAdminLoginLogic';
import styles from '../../../assets/styles/Admin/AdminLogin.module.scss';

export const AdminLogin = () => {
	const { formik } = useAdminLoginLogic();
	const {
		handleChange,
		handleBlur,
		handleSubmit,
		setFieldValue,
		values,
		errors,
		touched,
		isSubmitting,
	} = formik || {};

	return (
		<div className={styles.main}>
			<div className={styles.formContainer}>
				<MimaText mb={2} variant="subtitleBold" align="center">
					Login as Admin
				</MimaText>
				<form onSubmit={handleSubmit}>
					<MimaInput
						labelTitle="Email address"
						type="text"
						placeholder="Enter your email address"
						id="email"
						name="email"
						value={values.email}
						onChange={handleChange}
						onBlur={handleBlur}
						error={errors.email}
						touched={touched.email}
						mb={2}
						variant="form"
					/>
					<MimaInput
						labelTitle="Password"
						type="text"
						placeholder="Enter your password"
						id="password"
						name="password"
						value={values.password}
						onChange={handleChange}
						onBlur={handleBlur}
						passwordIcon
						error={errors.password}
						touched={touched.password}
						variant="form"
						mb={2}
					/>
					<MimaButton
						title="Login"
						type="submit"
						loading={isSubmitting}
						variant="form"
						buttonColor="var(--color-fash-black)"
					/>
				</form>
			</div>
		</div>
	);
};

export default AdminLogin;
